const LOWERCASE = 'abcdefghjkmnpqrstuvwxyz';
const UPPERCASE = 'ABCDEFGHJKMNPQRSTUVWXYZ';
const NUMBERS = '23456789';
const SYMBOLS = '!@#$%*-_';
const PASSWORD_ALPHABET = `${LOWERCASE}${UPPERCASE}${NUMBERS}${SYMBOLS}`;

const secureRandomIndex = (length) => {
  if (typeof window !== 'undefined' && typeof window.crypto?.getRandomValues === 'function') {
    const values = new Uint32Array(1);
    window.crypto.getRandomValues(values);
    return values[0] % length;
  }
  return Math.floor(Math.random() * length);
};

const pick = (characters) => characters[secureRandomIndex(characters.length)];

export const passwordChecks = (password = '') => ({
  length: password.length >= 10,
  uppercase: /[A-Z]/.test(password),
  lowercase: /[a-z]/.test(password),
  number: /\d/.test(password),
});

export const isStrongPassword = (password = '') => (
  Object.values(passwordChecks(password)).every(Boolean)
);

export const generateTemporaryPassword = (length = 14) => {
  const safeLength = Math.max(10, length);
  const requiredCharacters = [
    pick(LOWERCASE),
    pick(UPPERCASE),
    pick(NUMBERS),
    pick(SYMBOLS),
  ];

  while (requiredCharacters.length < safeLength) {
    requiredCharacters.push(pick(PASSWORD_ALPHABET));
  }

  for (let index = requiredCharacters.length - 1; index > 0; index -= 1) {
    const swapIndex = secureRandomIndex(index + 1);
    [requiredCharacters[index], requiredCharacters[swapIndex]] = [
      requiredCharacters[swapIndex],
      requiredCharacters[index],
    ];
  }

  return requiredCharacters.join('');
};
